import { render, staticRenderFns } from "./myOrderDetail.vue?vue&type=template&id=308f6485&scoped=true"
import script from "./myOrderDetail.vue?vue&type=script&lang=js"
export * from "./myOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./myOrderDetail.vue?vue&type=style&index=0&id=308f6485&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308f6485",
  null
  
)

export default component.exports